import URL from 'url-parse';
import qs, { ParsedQs } from 'qs';

export interface ParsedUrl {
  readonly auth: string;
  readonly hash: string;
  readonly host: string;
  readonly hostname: string;
  readonly href: string;
  readonly origin: string;
  readonly password: string;
  readonly pathname: string;
  readonly port: string;
  readonly protocol: string;
  readonly query: ParsedQs;
  readonly slashes: boolean;
  readonly username: string;
  toString(stringify?: (query: object) => string): string;
}

export const parseUrl = (url: string): ParsedUrl => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any
  return new URL(url, (query: string) => qs.parse(query, { ignoreQueryPrefix: true })) as any;
};
